<form [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
  <header class="info-tile-alt heading-row">
    <!-- <div *ngIf="drawName?.length > 10" tooltip="{{drawName}}" offset="0" zIndex="20000" placement="bottom"
             class="title-container">
            <h2>Assign Activities for {{drawName.substring(0, 10)}}...</h2>
        </div> -->
    <div tooltip="{{drawName}}" offset="0" zIndex="20000" placement="bottom" class="title-container">
      <h2>Assign Activities for {{drawName}}</h2>
    </div>
    <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </div>
  </header>
  <section class="sideRight-body">
    <table class="assign-activities-checklist" cellpadding="5" cellspacing="5">
      <tr>
        <div>
          If you cannot find any specific activity here, please check if you have selected them in
          <a routerLinkActive="active" (click)="navigateToProjectsAndActivities()" class="dataimport-link">Define
            Projects &
            Activities</a>.
        </div>
      </tr>
      <tr *ngIf="activities && activities.length!==0">
        <td>
          <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
            <input type="checkbox" [checked]="selectAll" (change)="SelectAll($event)" /><span>Select All</span>

          </label>
        </td>
      </tr>
      <tr *ngFor="let activity of activities">
        <td>
          <label class="datatable-checkbox child-checkbox"
            [ngClass]="activity.indeterminate ? 'projectchk' : 'kpmg-checkbox'"
            [ngStyle]="{'font-style':activity.activityType===0?'normal':'italic'}">
            <input class="indeterminate-input" type="checkbox" [checked]="activity.isSelected"
              [indeterminate]="activity.indeterminate"
              (change)="SetActivities(activity,$event)" /><span>{{activity.activityName}} - {{activity.qPercentage}}%
              Qualified</span>
            &nbsp;
          </label>
        </td>
      </tr>
    </table>
    <span class="d-flex justify-content-end">{{selectedActivities.length}} Activities Selected</span>
  </section>
  <footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-success" [disabled]="isAddDisabled" (click)="submitActivities()">Add
      Selected</button>
    <button type='button' class="btn kpmg-button--flat"
      (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>
</form>